import { createContext, useContext, useState } from 'react'

const EmployeeContext = createContext()

export const EmployeeContextProvider = ({ children }) => {
  const [selectedEmployee, setEmployee] = useState(null)

  return (
    <EmployeeContext.Provider
      value={{
        selectedEmployee,
        setEmployee,
      }}
    >
      {children}
    </EmployeeContext.Provider>
  )
}

export const useEmployeeContext = () => {
  return useContext(EmployeeContext)
}
